
import { Component, Prop, Vue } from 'vue-property-decorator';
import VTable from '@/components/shared/table/VTable.vue';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import { Venue } from '@/interfaces/models/Venue';
import { PosSync } from '@/interfaces/models/PosSync';
import { PosSyncStatus } from '@/enums/PosSyncStatus';
import headers from './headers';

@Component({
  components: { VTable },
})
export default class PosSyncTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: PosSync[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Array, required: true }) public venues!: Venue[];

  public headers: ColumnHeader[] = headers;

  public posSyncStatusColor(status: PosSyncStatus): string {
    return status === PosSyncStatus.IN_PROGRESS || status === PosSyncStatus.CREATED
      ? 'grey lighten-3'
      : status === PosSyncStatus.FAILED
      ? 'red lighten-3'
      : 'green lighten-3';
  }

  public getVenueName(venueId: string): string {
    if (!venueId) {
      return '';
    }

    const venue = this.venues.find((v: Venue) => v._id === venueId);

    return venue ? venue.name : venueId;
  }
}
